import React, { Component } from "react";
import "@/css/layout.css";

interface ILayoutProps {
  className?: string;
  children?: React.ReactNode;
}

export default class Layout extends Component<ILayoutProps> {
  render() {
    const { className, children } = this.props;
    const classes = ["justify-self-center", className].filter(Boolean).join(" ");

    return <div className={classes}>{children}</div>;
  }
}